import { render } from "./taleRecr.vue?vue&type=template&id=2b3103cc&scoped=true"
import script from "./taleRecr.vue?vue&type=script&lang=js"
export * from "./taleRecr.vue?vue&type=script&lang=js"

import "./taleRecr.vue?vue&type=style&index=0&id=2b3103cc&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2b3103cc"

export default script